// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qa4H","col":"styles_col__1BUyL"};